const badgeUsageTypeEnum = {
  COMPLETION: 0,
  SUCCESS: 1,
}
const data = [
  {
    id: badgeUsageTypeEnum.COMPLETION,
    title: 'Completion Badge',
    description: 'Awarded to learners who complete the entire course.',
  },
  {
    id: badgeUsageTypeEnum.SUCCESS,
    title: 'Success Badge',
    description:
      'Awarded to learners who meet or exceed the success criteria you set.',
  },
]
export default data
